var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealth25(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 31.5,
    transform: "translate(31.5 31.5)",
    fill: "#393c46",
    fillOpacity: 0.32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.679792 17.083953)",
    mask: "url(#ebc3vJ7W2y07)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 20.2106,
    transform: "matrix(.957335 0 0 1 18.0022 13.7517)",
    fill: "#646874"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.6323,
    height: 8.3561,
    rx: 0,
    ry: 0,
    transform: "translate(4.07446 20.6465)",
    fill: "#c75454"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ebc3vJ7W2y07",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2258,5.94297C30.7293,4.78,30.0134,3.72613,29.1181,2.84035c-.8959-.88842-1.9522-1.59444-3.1114-2.079656-1.2021-.505139-2.4914-.763698-3.793-.760668-1.8262,0-3.6079.505863-5.1562,1.461384-.3704.22857-.7223.47963-1.0557.75317-.3333-.27354-.6852-.5246-1.0556-.75317-1.5484-.955521-3.3301-1.461384-5.15619-1.461384-1.31497,0-2.58919.254805-3.79303.760668C4.83389,1.24782,3.78562,1.94853,2.88552,2.84035c-.89642.88478-1.61249,1.9389-2.107653,3.10262C0.262993,7.1533,0,8.43856,0,9.7613c0,1.2478.251881,2.548.751938,3.8708.418562,1.1054,1.018632,2.252,1.785392,3.4099c1.21495,1.8323,2.88551,3.7434,4.95982,5.6806c3.43745,3.2113,6.84155,5.4296,6.98595,5.5195l.8779.5696c.389.2511.889.2511,1.2779,0l.8779-.5696c.1445-.0936,3.5449-2.3082,6.986-5.5195c2.0743-1.9372,3.7449-3.8483,4.9598-5.6806.7668-1.1579,1.3706-2.3045,1.7854-3.4099.5001-1.3228.752-2.623.752-3.8708.0037-1.32274-.2593-2.608-.7742-3.81833Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth25);
export default __webpack_public_path__ + "static/media/health-25.6b5e493049298d1640335a0f11dd2b91.svg";
export { ForwardRef as ReactComponent };